import { useSearchParams } from 'react-router-dom';
import { InviteForm } from '@/components/invite-form';
import { AuthShell } from '@/components/auth-shell';

export default function InvitePage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  return (
    <AuthShell>
      {token ? (
        <InviteForm token={token} />
      ) : (
        <div className="rounded-goutte border border-rule bg-white p-8 text-center">
          <h1 className="font-display text-[30px] font-extrabold tracking-[-0.03em] text-ink">Lien invalide</h1>
          <p className="mt-2 text-sm text-ink-muted">
            Ce lien d'invitation n'est pas valide. Veuillez contacter votre administrateur.
          </p>
        </div>
      )}
    </AuthShell>
  );
}
